module.exports = __webpack_public_path__ + "img/content-items.562501e.jpg";